module.exports = __webpack_public_path__ + "img/img-3-7.b842c68e.webp";